import { viewSectionStandar } from "@/utils";

const getDefaultState = () => ({
	isLoading: false,
	viewSectionAccounts: "allAccounts",
	viewSectionItems: "topChoice",

	accountSelectedId: null,
	newAccount: null,
	isChangeTable: false,
	descriptionZone: null,

	unifyAccounts: {
		originReservationId: null,
		destinationReservationId: null,
	},

	destinationAccountProductsOrders: null,
	listProductsSelected: [],
	partialPaymentTotal: 0,
	partialPaymentProductOrderIds: [],
	isAccountSelectedForUnify: false,
	isAddProductsCartInAccount: false,
	isAccountMoveProducts: false,

	selectedTables: [],
});

const state = getDefaultState();

const getters = {
	isLoading: (state) => {
		return state.isLoading;
	},
	partialPaymentTotal: (state) => {
		return state.partialPaymentTotal
	},
	partialPaymentProductOrderIds: (state) => {
		return state.partialPaymentProductOrderIds.length ? state.partialPaymentProductOrderIds : state.listProductsSelected;
	},
	viewSectionAccounts: (state) => {
		return state.viewSectionAccounts;
	},
	viewSectionItems: (state) => {
		return state.viewSectionItems;
	},

	accountSelectedId: (state) => {
		return state.accountSelectedId;
	},
	newAccount: (state) => {
		return state.newAccount;
	},
	isChangeTable: (state) => {
		return state.isChangeTable;
	},

	descriptionZone: (state) => {
		return state.descriptionZone;
	},
	unifyAccounts: (state) => {
		return state.unifyAccounts;
	},
	destinationAccountProductsOrders: (state) => {
		return state.destinationAccountProductsOrders;
	},

	listProductsSelected: (state) => {
		return state.listProductsSelected;
	},

	isAccountSelectedForUnify: (state) => {
		return state.isAccountSelectedForUnify;
	},

	isAddProductsCartInAccount: (state) => {
		return state.isAddProductsCartInAccount;
	},
	isAccountMoveProducts: (state) => {
		return state.isAccountMoveProducts;
	},

	selectedTables: (state) => state.selectedTables,
};

const mutations = {
	setIsLoading: (state, payload) => {
		state.isLoading = payload;
	},
	setPartialPaymentTotal(state, total) {
		state.partialPaymentTotal = Number(total) || 0;
	},
	setPartialPaymentProductOrderIds(state, ids) {
		state.partialPaymentProductOrderIds = Array.isArray(ids) ? ids : [];
	},
	setViewSectionAccounts(state, sectionAccounts) {
		state.viewSectionAccounts = sectionAccounts;
	},
	setViewSectionItems(state, sectionItems) {
		state.viewSectionItems = sectionItems;
	},

	setAccountSelectedId(state, accountId) {
		state.accountSelectedId = accountId;
	},
	setNewAccount(state, newAccount) {
		state.newAccount = newAccount;
	},

	updateNewAccount(state, payload) {
		state.newAccount = {
			...state.newAccount,
			...payload,
		};
	},

	setIsChangeTable(state, payload) {
		state.isChangeTable = payload;
	},
	setDescriptionZone(state, payload) {
		state.descriptionZone = payload;
	},

	setDestinationAccountProductsOrders(state, payload) {
		state.destinationAccountProductsOrders = payload;
	},
	setIsAccountMoveProducts(state, payload) {
		state.isAccountMoveProducts = payload;
	},

	setListProductsMoveAccount(state, payload) {
		state.listProductsSelected = payload;
	},
	addListProductsSelected(state, productId) {
		if (!state.listProductsSelected.includes(productId)) {
			state.listProductsSelected.push(productId);
		}
	},
	removeListProductsSelected(state, productId) {
		state.listProductsSelected = state.listProductsSelected.filter((id) => id !== productId);
	},
	clearListProductsSelected(state) {
		state.listProductsSelected = [];
		state.partialPaymentProductOrderIds = [];
		state.partialPaymentTotal = 0;
	},

	setUnifyAccounts(state, payload) {
		state.unifyAccounts = {
			...state.unifyAccounts,
			...payload,
		};
	},
	setIsAccountSelectedForUnify(state, payload) {
		state.isAccountSelectedForUnify = payload;
	},
	setIsAddProductsCartInAccount(state, payload) {
		state.isAddProductsCartInAccount = payload;
	},

	resetState(state) {
		Object.assign(state, getDefaultState());
	},

	setSelectedTables(state, tables) {
		state.selectedTables = tables;
	},
	toggleSelectedTable(state, table) {
		const index = state.selectedTables.findIndex((t) => t.table_id === table.table_id);
		if (index !== -1) {
			state.selectedTables.splice(index, 1);
		} else {
			state.selectedTables.push(table);
		}
	},
	clearSelectedTables(state) {
		state.selectedTables = [];
	},
};

const actions = {
	updateProductSelection({ commit }, { productId, isSelected }) {
		if (isSelected) {
			commit("addListProductsSelected", productId);
		} else {
			commit("removeListProductsSelected", productId);
		}
	},

	resetAllStates({ commit }) {
		commit("resetState");
		commit("copilot/setReservationId", null, { root: true });
		commit("copilot/setSelectedReservationId", { reservationId: null }, { root: true });
		commit("copilot/setCommanderReservation", { commanderReservation: null }, { root: true });
		commit("reservation/setReservation", null, { root: true });
		viewSectionStandar();
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
